import React from 'react';
import VConsole from 'vconsole';
import { createStore } from 'redux';
import { Provider } from 'react-redux';

import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import rootReducer from './reducers';
import CONFIG from 'GlobalConfigFile';

const store = createStore(rootReducer)

// uat环境增加vconsole
if (CONFIG.Server === 'uat') {
  const vconsole = new VConsole();
}
ReactDOM.render(
  <React.StrictMode>
     <Provider store={store}>
        <App />
     </Provider>
  </React.StrictMode>,
   document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
